import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { SurfacesContext } from 'js/analytics/autotest/AutotestAnalytics';

export class ImpactBox extends React.Component {
  static propTypes = {
    statCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      .isRequired,

    // noun *or* label is required
    statNoun: PropTypes.string,
    statLabel: PropTypes.string,

    columnLabels: PropTypes.array.isRequired,
    panelRows: PropTypes.array.isRequired,
    modalRows: PropTypes.array.isRequired,
    mobile: PropTypes.bool,
  };

  showModal = () => {
    if (this.modalEl) {
      $(this.modalEl).modal('show');
    }
  };

  setupModal = (el) => {
    if (el) {
      this.modalEl = el;
    }
  };

  renderMask = (label) => {
    return (
      <tr key="loadingMask">
        <td className="u-bgColorGrayLightest"></td>
        <td className="u-bgColorGrayLightest">
          <div
            className="u-positionAbsolute"
            style={{
              top: 0,
              right: 0,
              left: 0,
              bottom: 0,
              borderRadius: '4px',
            }}
          >
            <div
              className="u-positionAbsolute u-taCenter u-textUppercase u-tcGrayDark u-fw500"
              style={{
                top: '50%',
                width: '100%',
                transform: 'translateY(-50%)',
              }}
            >
              {label}
            </div>
          </div>
        </td>
      </tr>
    );
  };

  renderTable = (options) => {
    const tableClasses = options.tableClasses || '';
    const cellClasses =
      'u-fs11 u-borderBottom0 u-ph4x u-pv1x u-tcGrayDarker u-fw500 u-whiteSpaceNowrap';
    const labels = this.props.columnLabels;

    return (
      <table
        className={
          'analytics-dashboard-data-table table u-mb0x u-bgColorWhite ' +
          tableClasses
        }
      >
        <thead>
          <tr className="u-bgColorGrayLightest">
            <th key={labels[0]} className={cellClasses}>
              {labels[0]}
            </th>
            <th
              key={labels[1]}
              className={cellClasses}
              style={{ width: '75px' }}
            >
              <span className="u-floatRight">{labels[1]}</span>
            </th>
          </tr>
        </thead>
        <tbody>{options.rows}</tbody>
      </table>
    );
  };

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  panelFooter = (displayingData) => {
    const more = this.props.modalRows.length - this.props.panelRows.length;
    if (more > 0) {
      return (
        <div
          className="panel-footer u-taCenter u-fw700 u-textUppercase u-tcGrayDark u-clickable u-bgColorWhite"
          onClick={this.showModal}
        >
          {more} MORE
        </div>
      );
    } else {
      return <div className="panel-footer u-bgColorGrayLightest">&nbsp;</div>;
    }
  };

  statLabel = () => {
    if (this.props.statLabel) {
      return this.props.statLabel;
    } else {
      return $h.pluralize(this.props.statCount, this.props.statNoun);
    }
  };

  statCount = () => {
    if (this.props.loading) {
      return '\u2014'; // mdash
    } else if (typeof this.props.statCount === 'number') {
      return $h.commaizeInt(this.props.statCount);
    } else {
      return this.props.statCount;
    }
  };

  render() {
    let panelRows;
    let displayingData;
    if (this.props.loading) {
      panelRows = this.props.panelRows
        .slice(0, -1)
        .concat([this.renderMask('LOADING…')]);
      displayingData = false;
    } else if (!this.props.modalRows.length) {
      panelRows = this.props.panelRows
        .slice(0, -1)
        .concat([this.renderMask('NO DATA AVAILABLE')]);
      displayingData = false;
    } else {
      panelRows = this.props.panelRows;
      displayingData = true;
    }

    const tableContainerClasses = classNames(
      'impact-tab-box-table',
      'u-bgColorGrayLightest',
      { 'u-positionRelative': !displayingData },
    );

    // Autotest KPI typography slot (defaults == the original utility classes),
    // shared with ImpactTopStat so B1–B3 restyle every stat tile, not just the
    // three summary tiles.
    const kpi = this.context.kpiTileTypography;
    const statClassName = [
      kpi.fontSizeClass,
      kpi.lineHeightClass,
      kpi.weightClass,
      kpi.colorClass,
    ]
      .filter(Boolean)
      .join(' ');
    const labelClassName = [kpi.paddingClass, kpi.labelClass]
      .filter(Boolean)
      .join(' ');
    return (
      <div className={this.props.mobile ? '' : 'col-xs-4'}>
        <div className="panel panel-flat a-fadeInDown">
          <div className="panel-heading u-tcGrayDarker u-fs18 u-fw300 u-pv10x u-taCenter">
            <div className="u-clearfix">
              <span className={statClassName}>{this.statCount()}</span>
              {!this.props.loading && this.props.statCountExtra}
              <div className={labelClassName}>{this.statLabel()}</div>
            </div>
          </div>
          <div
            className={tableContainerClasses}
            style={{
              borderBottomLeftRadius: '3px',
              borderBottomRightRadius: '3px',
            }}
          >
            {this.renderTable({ rows: panelRows })}
            {displayingData && this.panelFooter()}
          </div>
        </div>
        <div className="modal" ref={this.setupModal}>
          <div className="modal-dialog">
            <div className="modal-content u-overflowHidden">
              <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                <div className="modal-header u-ph5x u-pv6x">
                  <div className="media_v2">
                    <div className="media-left media-middle u-fs36 u-lineHeight1">
                      <span className="u-fw300 u-tcGrayDarkest">
                        {this.statCount()}
                      </span>
                    </div>
                    <div className="media-body media-middle">
                      <span className="u-fs16 u-fw500 u-tcGrayDark">
                        {this.statLabel()}
                      </span>
                    </div>
                    <div className="media-right media-middle">
                      <span
                        className="u-clickable u-fs36 u-tcGray"
                        data-dismiss="modal"
                      >
                        ×
                      </span>
                    </div>
                  </div>
                </div>
                {this.renderTable({ rows: this.props.modalRows })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ImpactBox.contextType = SurfacesContext;
